/* unplugin-vue-components disabled */import { render } from "./ThumbnailGeneratorModal.vue?vue&type=template&id=c816df64&scoped=true&ts=true"
import script from "./ThumbnailGeneratorModal.vue?vue&type=script&lang=ts"
export * from "./ThumbnailGeneratorModal.vue?vue&type=script&lang=ts"

import "./ThumbnailGeneratorModal.vue?vue&type=style&index=0&id=c816df64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c816df64"]])

export default __exports__